import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

/**
 * Interface for deactivation guard
 */
export interface CanComponentDeactivate {
  canDeactivate(): Observable<boolean>|Promise<boolean>|boolean;
}

/**
 * Can inject into other components
 */
@Injectable({providedIn: 'root'})
export class DeactivateGuard  {

  /**
   * Returns the boolean value of the components canDeactivate function
   */
  public canDeactivate(component: CanComponentDeactivate): Observable<boolean>|Promise<boolean>|boolean {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
